{
  "menu": {
    "dashboard": "Tableau de bord",
    "individuals": "Individus",
    "nonIndividualClients": "Entités non individuelles",
    "households": "Ménages",
    "portfolioManagement": "Portefeuilles",
    "clientManagement": "Clients",
    "corporations": "Sociétés",
    "modelPortfolios": "Portefeuilles modèles",
    "modelPortfoliosV2": "Portefeuilles modèles v2",
    "buildModels": "Construire des modèles",
    "modelFamily": "Famille de modèles",
    "portfolioTemplates": "Modèles",
    "productShelfPage": "Étagère de produits",
    "assetClassesPage": "Classes d'actifs",
    "tradingSchedules": "Calendriers de négociation",
    "trading": "Négociation",
    "reports": "Rapports",
    "rebalancing": "Rééquilibrage",
    "bulkTrader": "Négociation en lot",
    "bulkImport": "Importation en lot",
    "taxLossHarvesting": "Récupération de pertes fiscales",
    "compliance": "Conformité",
    "complianceReview": "Examen de conformité",
    "transactionMonitoringTool": "Outil de surveillance des transactions",
    "elderlyClients": "Clients âgés",
    "bankAccountsToReview": "Approbation de nouveaux comptes bancaires",
    "institutionsToReview": "Approbation des institutions",
    "operations": "Opérations",
    "reconciliation": "Réconciliation",
    "transactions": "Toutes les transactions",
    "accountsReview": "Examen des comptes",
    "settings": "Paramètres",
    "orgSettings": "Organisation",
    "newsAndInsights": "Actualités et informations",
    "devSettings": "Intégration",
    "bulkUpsertRequests": "Demandes de mise à jour en lot",
    "language": "Langue",
    "logout": "Déconnexion",
    "addNewEntity": "Ajouter un nouveau profil",
    "viewAllProfiles": "Voir tous les profils",
    "resourcesArticles": "Ressources et articles",
    "contactSupport": "Contacter le support",
    "actions": "Actions",
    "statementsReview": "Examen des relevés",
    "systemManagement": "Paramètres",
    "rebalanceReport": "Rapport de rééquilibrage",
    "portfolioOptimizer": "Optimiseur de portefeuille",
    "annualSuitabilityReview": "Mise à jour annuelle des informations du profil",
    "feeAndBilling": "Frais et facturation",
    "billingManagement": "Gestion de la facturation",
    "feeGrids": "Grilles de frais",
    "billingSchedules": "Calendriers de facturation",
    "incurredFees": "Gestion de la facturation",
    "workflows": "Flux de travail",
    "configureWorkflow": "Configurer le flux de travail",
    "pageConfiguration": "Configurer la page",
    "staticPageWidgetConfiguration": "Configurer le widget de page fixe",
    "clientReportTemplate": "Modèle de rapport client",
    "formTemplateEditor": "Éditeur de modèle de formulaire",
    "general": "Général",
    "theme": "Thème",
    "designer": "Concepteur",
    "textDesigner": "Design de texte",
    "authenticationTheme": "Concepteur d'authentification",
    "errorTheme": "Page d'erreur",
    "roles": "Rôles",
    "roleSettings": "Paramètres des rôles",
    "users": "Utilisateurs",
    "authentication": "Authentification",
    "accessSettings": "Paramètres d'accès",
    "custodianAndAccounts": "Comptes",
    "accounts": "Comptes disponibles",
    "accountsList": "Comptes",
    "accountGroupsList": "Groupes de comptes",
    "custodianConnections": "Connexions au dépositaire",
    "productExperience": "Expérience produit",
    "dashboards": "Tableaux de bord",
    "localization": "Localisation",
    "notifications": "Notifications",
    "forms": "Formulaires",
    "statementsAndTaxDocuments": "Relevés et documents fiscaux",
    "customFields": "Champs personnalisés",
    "repCodes": "Codes de représentant",
    "pageConfigurations": "Configurations de page",
    "staticPageWidgetConfigurations": "Configurations de widgets de page fixe",
    "downtimeSchedule": "Calendrier de maintenance",
    "transfers": "Transferts",
    "trades": "Transactions",
    "assetClasses": "Classes d'actifs",
    "portfolioManagements": "Gestion de portefeuille",
    "portfolioManagementSettings": "Paramètres de gestion de portefeuille",
    "feesAndBilling": "Frais et facturation",
    "embedded": "Intégré",
    "apiTokens": "Jetons API",
    "webhooks": "Liens de rappel",
    "integrations": "Intégrations",
    "accessUsers": "Utilisateurs d'accès",
    "clientReports": "Rapports clients",
    "roleProfiles": "Profils de rôles",
    "taxRankings": "Classements fiscaux",
    "localizationConfiguration": "Configuration de localisation",
    "generalProductExperience": "Général",
    "formDefinitions": "Définitions de formulaires",
    "formMapper": "Mappeur de formulaires",
    "featureFlags": "Indicateurs de fonctionnalités",
    "homePageConfiguration": "Configuration de la page d'accueil",
    "homePageConfigurations": "Configurations de la page d'accueil",
    "customAttributeLabels": "Étiquettes d'attributs personnalisés",
    "accountSettings": "Paramètres de compte",
    "configurableTablePages": "Pages de tableaux configurables",
    "configurableTablePage": "Page de tableau configurable",
    "alertBanners": "Bannières d'alerte",
    "bulkTraderRevamp": "Négociation en lot (Refonte)",
    "flags": "Indicateurs",
    "flagPolicies": "Politiques d'indicateurs",
    "feeSettings": "Général",
    "accountGroupSettings": "Paramètres du groupe de comptes",
    "rebalanceDashboard": "Tableau de bord de rééquilibrage",
    "activities": "Activités"
  }
}
